<template>
  <div ref="dialog_layer" v-if="dialog_visible>0" tabindex="-1" :class="['grcdialog-layer']" 
        v-bind:style="{'left': layer_left, 'top': layer_top, 'min-width':layer_width+'px', 'min-height':layer_height+'px', 'width':'100%', 'height':'100%', 'background-color':'rgba(255,255,255,0.9)' }"
        @keydown="DialogKeydown"
  >
                    <div :class="['grcdialog-cont']" 
                    v-bind:style="{'width':cont_width+'px', 'height':cont_height+'px', 'top':dialog_top+'px', 'left':dialog_left+'px' }"
                    >
                        <div class="grcdialog-title" :class="['grcdialog-title', 
                        color=='white' ? 'grcdialog-title-white' : '',
                        color=='yellow' ? 'grcdialog-title-yellow' : '',
                        color=='grey' ? 'grcdialog-title-grey' : '',
                        color=='green' ? 'grcdialog-title-green' : '',
                        color=='red' ? 'grcdialog-title-red' : '',
                        color=='blue' ? 'grcdialog-title-blue' : '',
                         ]"  
                         v-html="title"
                         @mousedown="onTitleMouseDown"
                         >
                        </div>
                        <div class="grcdialog-text" style="padding:0px;">
                            <iframe ref="payment_frame" name="payment_frame" v-bind:style="{'width':'100%', 'height':'calc(100% - 6px)', 'border':'none' }" ></iframe>
                        </div>

                        <div class="grcdialog-button-cont">

                          <span ref="btn" class="cms_linkbutton cms_linkbutton_OK" v-show="PayButtonID>0"
                            style="margin-left:0px;"
                            @click="ButtonClick()"
                            >
                            <span v-html="btntext"></span>
                          </span>

                        </div>
                    </div>
  </div>
</template>

<script>

import Vue from 'vue';
import GrcButton from '../GrcComponents/GrcButton.vue'

export default {
  name: 'GrcDialogPayment_SimpleV2',
  components:
  {
    GrcButton
  },
  props: {
  },
  data () {
    return {
        layer_left:0,
        layer_top:0,
        layer_width:300,
        layer_height:250,
        dialog_visible: 0,
        cont_width:0,
        cont_height:0,
        title:"",
        text:"",
        color:"",
        dialog_top:0,
        dialog_left:0,

        default_padding_top: 100,
        default_cont_width:300,
        default_cont_height: 250,
        
        buttons:[],
        button_focus_index:-1,

        move_mouse_startX:-1,
        move_mouse_startY:-1,
        move_dialog_startX:-1,
        move_dialog_startY:-1,

        PaymentParams:[],

        PayButtons:[
            "None", "Megszakítom", "Bezárom", "Rendben"
        ],

        PayButtonID:0,

        btntext:"",

        PromiseResultObject: null
    }
  },
  watch : {
  },

  created: function()
  {
  },
  computed: {
  },
  updated: function() {

    this.$nextTick(function () {

      if (this.dialog_visible == 1)
      {
        this.PayButtonID = 1;

        this.btntext = this.PayButtons[this.PayButtonID];

        this.dialog_visible = 2;

        this.button_focus_index = -1;
        for(var i=0;i<this.buttons.length;i++)
        {
          if (this.buttons[i].default == true) { this.button_focus_index = i; }
        }
        this.FocusButton();

        this.PreparePayment();
      }
    });
  },

  mounted: function () {

    document.addEventListener('mousemove',  this.MouseMove);
    document.addEventListener('mouseup',  this.MouseUp);

    window.addEventListener("message", this.onMessage, false);
  },

  destroyed: function()
  {
    document.removeEventListener('mousemove',  this.MouseMove);
    document.removeEventListener('mouseup',  this.MouseUp);
    window.removeEventListener("message", this.onMessage, false);
  },


  methods: {

    onMessage(e)
    {
        //e.data
        if (typeof this.PaymentParams.PAYMENT == 'undefined') { return; }
        if (this.PaymentParams.PAYMENT[0].ORDER_REF != e.data.order_ref) { return; }

        //alert(e.origin);
        //alert("order_ref: "+e.data.order_ref);

        if (e.data.fnc == "btnchange")
        {
            this.PayButtonID = e.data.param1;
            this.btntext = this.PayButtons[this.PayButtonID];
            return;
        }

        if (e.data.fnc == "close")
        {
            this.ButtonClick();
            return;
        }

    },

    onTitleMouseDown(e)
    {
      this.move_mouse_startX = e.pageX;
      this.move_mouse_startY = e.pageY;
      this.move_dialog_startX = this.dialog_left;
      this.move_dialog_startY = this.dialog_top;
    },

    MouseMove(e)
    {
      if (this.move_mouse_startX < 0) { return; }

      this.dialog_left = this.move_dialog_startX + (e.pageX - this.move_mouse_startX);
      this.dialog_top = this.move_dialog_startY + (e.pageY - this.move_mouse_startY);
    },

    MouseUp(e)
    {
      this.move_mouse_startX = -1;
    },


    PreparePayment()
    {
        //console.log(this.$refs.payment_frame);
        //console.log(this.PaymentParams);

        let Q = this.PaymentParams;

        var myForm = document.createElement("form");
        myForm.method = "get";
        myForm.action = Q.PAYMENT[0].SimpleUrl;
        myForm.target = "payment_frame";
        var myInput;

        document.body.appendChild(myForm);
        myForm.submit();
        document.body.removeChild(myForm);        
    },


    ShowDialog(pParams, Q)
    {
        this.$emit("popupopened");

        grcmain_SetBodyScrollable(false);

        var title = pParams.title;
        var text = pParams.text;
        var color = pParams.color;
        var width = pParams.width;
        var height = pParams.height;
        var padding_top = pParams.padding_top;

        var isCentered = false;
        

        if (title == undefined) { title = ""; }
        if (text == undefined) { text = ""; }
        if (color == undefined) { color = "white"; }
        if (width == undefined) { width = this.default_cont_width; }
        if (height == undefined) { height = this.default_cont_height; }
        if (padding_top == undefined) { isCentered = true; }
        if (padding_top == -1) { isCentered = true; }


        //var bs = grccomp_getBodySize();
        var bs = grccomp_getScreenSize();

        this.layer_width = bs.width;
        this.layer_height = bs.height;

        if (width >= bs.width) { width = bs.width - 10; }
        //if (height > bs.height-50) { height = bs.height - 10-50; }
        if (height >= bs.height) { height = bs.height - 10; }

        //console.log(bs.height);
        //console.log(height);

        var left = (bs.width - width) / 2;
        var top = (bs.height - height) / 2;
        if (isCentered == false) 
        { 
          top = padding_top; 
        }
        else
        {
          if (top > 0) { top = top/2; }
        }


        this.title = title;
        this.text = text;
        this.color = color;
        this.cont_width = width;
        this.cont_height = height;
        this.dialog_top = top;
        this.dialog_left = left;

        this.PaymentParams = Q;
       
        this.dialog_visible = 1;

        return new Promise((resolve, reject) => {
          this.PromiseResultObject = resolve;
        });
    },

    Alert(pTitle, pText)
    {
      var params = grccomp_dialog_alert_GetDefaults(pTitle, pText);
      return this.ShowDialog(params);
    },

    Confirm(pTitle, pText)
    {
      var params = grccomp_dialog_yesno_GetDefaults(pTitle, pText);
      return this.ShowDialog(params);
    },



    DialogKeydown(e)
    {
      e.preventDefault();
      e.stopPropagation();
    },

    ButtonClick()
    {
        grcmain_SetBodyScrollable(true);
        this.$emit("popupclosed");
        this.dialog_visible = -1;
        
        // PayButtonID alapján visszatérő érték
        var res = this.PayButtonID.toString();

        this.PromiseResultObject(res);
    },

    CloseDropdown()
    {
        grcmain_SetBodyScrollable(true);
        this.$emit("popupclosed");
        this.dialog_visible = -1;
        var res = "ESC";
        this.PromiseResultObject(res);
    },

    ButtonPress(pKeyCode)
    {
      if (pKeyCode == 27)
      {
        grcmain_SetBodyScrollable(true);
        this.$emit("popupclosed");
        this.dialog_visible = -1;
        var res = "ESC";

        this.PromiseResultObject(res);
        return;
      }


      //console.log(pKeyCode+" "+pIndex);
    },

    FocusButton()
    {
        //this.$refs.btn.SetFocus();
        //this.$refs.dialog_layer.focus();        
    }

    
    
  }  // end: methods



}
</script>

